import React, { Component , Suspense} from 'react'
import { connect } from 'react-redux';
import { getSafe } from '../helpers/global';
import classnames from 'classnames';
import '../assets/styles/core/mobile-drawer-layout.scss';
import Spinner from '@/components/Spinner/LoadingSpinner';
class MobileDrawerLayout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        }
    }
    render() {
        const { children , theme} = this.props;
        const { isOpen } = this.state;

        return (
            <div className={classnames('mobile-drawer-layout-container', isOpen && 'mobile-drawer-layout-open', 'theme-'+ theme)} onClick={() => this.closeLayout()}>
                <div className={classnames("drawer-layout", isOpen && 'drawer-layout-open')} onClick={e => e.stopPropagation()}>
                    <div className="content">
                    <Suspense fallback={<Spinner/>}>
                    {React.cloneElement(children, { ...this.props, closeLayout: this.closeLayout})}
                    </Suspense>
                    </div>
                </div>
            </div>
        )
    }

    closeLayout = () => {
        this.setState({ isOpen: false })
        setTimeout(() => {
            this.props.onClose()
        }, 300)
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({ isOpen: true })
        }, 0)
    }
}

MobileDrawerLayout.defaultProps = {
    children: <div></div>
}

export default connect(
    state => ({
        language: state.app.language,
        theme: state.app.theme,
    })
)(MobileDrawerLayout)
